import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import * as sdk from 'pkg/core/sdk';
import { checkAndFixUrl } from 'pkg/url';

export async function update(
	organizationId: number,
	groupId: number,
	payload: models.groupContactInformation.GroupContactInformation
): Promise<
	[
		Response,
		models.groupContactInformation.GroupContactInformation,
		models.APIError?,
	]
> {
	if (groupId <= 0 || payload.length === 0) {
		return [new Response(null, { status: 400 }), null, null];
	}

	Object.values(payload).forEach((v, i) => {
		if (v.fieldType === 'url') {
			const newUrl = checkAndFixUrl(v.fieldValue);
			payload[i].fieldValue = newUrl;
		}
	});

	const endpoint = endpoints.GroupInfo.ShowByGroupID(organizationId, groupId);
	const request: Response = await sdk.put(endpoint, {}, payload);

	if (!request.ok) {
		const response: models.APIError = await request.json();

		return [request, null, response];
	}

	const response: models.groupContactInformation.GroupContactInformation =
		await request.json();

	return [request, response, null];
}
